import { isObject, isObjectEmpty } from '@lentau/ui-kit/core/utils/object.utils';
import { b2bUrl, methodNameRegExp } from './consts';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isNotJsonResponse: (body: any) => boolean = (body: any): boolean =>
  body && (typeof body === 'string' || body instanceof String);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmptyResponse: (url: string, body: any) => boolean = (url: string, body: any): boolean => {
  // Если это б2б, то там может быть любой ответ, а значит считается не пустым
  if (isB2b(url)) {
    return false;
  }

  if (body.hasOwnProperty('error')) {
    return isEmptyProperty(body, 'error');
  }

  if (url.includes('api/rest')) {
    return isEmptyProperty(body, 'Body');
  }

  if (url.includes('jrpc')) {
    return isEmptyProperty(body, 'result');
  }

  return false;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isErrorResponse: (body: any) => boolean = (body: any): boolean =>
  (body && body?.hasOwnProperty('Body') && body.Body?.hasOwnProperty('ErrorList')) || body?.hasOwnProperty('error');

export const isEmptyProperty: (obj: object, property: string) => boolean = (obj: object, property: string): boolean => {
  return !obj.hasOwnProperty(property) || isEmpty(obj[property]);
};

export const isB2b: (url: string) => boolean = (url: string): boolean => {
  return url.indexOf(b2bUrl) > -1;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmpty: (data: any) => boolean = (data: any): boolean => !data || (isObject(data) && isObjectEmpty(data));

export const getMethodNameFromOldRequest: (url: string, body: string) => string = (
  url: string,
  body: string
): string => {
  // B2b не подчиняется общим правилам
  if (!url || !body || isB2b(url)) {
    return null;
  } else {
    return new RegExp(methodNameRegExp, 'gi').exec(body)?.[1];
  }
};
